import { render, staticRenderFns } from "./suggestion-list-panel.vue?vue&type=template&id=87483f96&scoped=true"
import script from "./suggestion-list-panel.ts?vue&type=script&lang=ts&external"
export * from "./suggestion-list-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./suggestion-list-panel.scss?vue&type=style&index=0&id=87483f96&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87483f96",
  null
  
)

export default component.exports